import create from "zustand";
import { NftListing } from "../common/enums/common.enums";
import { NftSaleMarketplace } from "../common/enums/marketplace.enums";
import {
  IDetailNftData,
  IDetailNftDataWithProposalInfo,
} from "../common/interfaces/common.interface";

export interface IVaultStore {
  activeNfts: NftListing;
  setActiveNfts: (nftListing: NftListing) => void;
  allNfts: IDetailNftData[];
  setAllNfts: (nfts: IDetailNftData[]) => void;
  nftsOnSale: IDetailNftDataWithProposalInfo[];
  setNftsOnSale: (nftsOnSale: IDetailNftDataWithProposalInfo[]) => void;
  nftsOnBids: IDetailNftDataWithProposalInfo[];
  setNftsOnBids: (nfts: IDetailNftDataWithProposalInfo[]) => void;
  saleNftMarketplace: NftSaleMarketplace[];
  setSaleNftMarketplace: (saleMarketplace: NftSaleMarketplace[]) => void;
  emptyStore: () => void;
  updateNftsAfterAction: (
    nft: IDetailNftDataWithProposalInfo,
    nftListing: NftListing,
    isAdding?: boolean
  ) => void;
}

const initialVaultStore = {
  activeNfts: NftListing.AllNfts,
  allNfts: [],
  nftsOnSale: [],
  nftsOnBids: [],
  saleNftMarketplace: [],
};
export const vaultStore = create<IVaultStore>((set, get) => ({
  ...initialVaultStore,
  setActiveNfts: (newActiveNfts: NftListing) =>
    set(() => ({ activeNfts: newActiveNfts })),
  setAllNfts: (newNftsList: IDetailNftData[]) =>
    set(() => ({ allNfts: [...newNftsList] })),
  setNftsOnSale: (newNftsList: IDetailNftDataWithProposalInfo[]) =>
    set(() => ({ nftsOnSale: [...newNftsList] })),
  setNftsOnBids: (nftsonBids: IDetailNftDataWithProposalInfo[]) =>
    set(() => ({ nftsOnBids: [...nftsonBids] })),
  setSaleNftMarketplace: (saleMarketplace: NftSaleMarketplace[]) =>
    set(() => ({ saleNftMarketplace: [...saleMarketplace] })),
  updateNftsAfterAction: (
    nft: IDetailNftDataWithProposalInfo,
    nftListing: NftListing,
    isAdding?: boolean
  ) => {
    let addedNfts: IDetailNftDataWithProposalInfo[] = [];
    switch (nftListing) {
      case NftListing.Bids:
        addedNfts = [...get().nftsOnBids];
        const updatedNftsOnBids = updateAddedNfts(nft, addedNfts, isAdding);
        set({ nftsOnBids: updatedNftsOnBids });
        break;
      case NftListing.Sales:
        addedNfts = [...get().nftsOnSale];
        const updatedNftsOnSales = updateAddedNfts(nft, addedNfts, isAdding);
        set({ nftsOnSale: updatedNftsOnSales });
        break;
    }
  },
  emptyStore: () => set({ allNfts: [], nftsOnBids: [], nftsOnSale: [] }),
}));

const updateAddedNfts = (
  nft: IDetailNftDataWithProposalInfo,
  addedNfts: IDetailNftDataWithProposalInfo[],
  isAdding?: boolean
) => {
  if (isAdding) {
    return [...addedNfts, nft];
  }
  return [
    ...addedNfts.filter(
      (addedNft) => addedNft.mint.toString() !== nft.mint.toString()
    ),
  ];
};
